/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Media_Tab_Remove_ConfirmInputs */



/**
* | output |
* | --- |
* | "Remove {name}? This cannot be undone." |
*
* @param {Media_Tab_Remove_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_confirm = /** @type {((inputs: Media_Tab_Remove_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer ${i?.name} ? Cette opération est irréversible.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Soll ${i?.name} entfernt werden? Dies kann nicht rückgängig gemacht werden.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovere ${i?.name}? Questa operazione non può essere annullata.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.name}? Это невозможно отменить.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Eliminar ${i?.name}? Esto no se puede deshacer.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除${i?.name}？此操作无法撤销。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name}を削除しますか？これは元に戻せません。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को हटाएँ? इसे पूर्ववत नहीं किया जा सकता।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover ${i?.name}? Esta ação não pode ser desfeita.`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}? This cannot be undone.`)
});